module.exports = __webpack_public_path__ + "static/media/share-alt.a7afabc1.svg";